import { Routes } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { TermsComponent } from './terms/terms.component';
import {PolicyComponent}  from './policy/policy.component';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './auth/auth.guard';
import { ForgotComponent } from './forgot/forgot.component';
import { LoginComponent } from './login/login.component';
import { SamlLoginComponent } from './saml-login/saml-login.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { SecurityQuestionComponent } from './security-question/security-question.component';
import { HLRegistrationComponent } from './hl-registration/hl-registration.component';
import { OtpComponent } from './otp/otp.component';
import { SecuityquestionredirectComponent } from './secuityquestionredirect/secuityquestionredirect.component';
import { accountResolverService } from './services/account-resolver.service';
import { productResolver } from './services/product-resolver.service';
import { TfgWhatsappComponent } from './tfg-whatsapp/tfg-whatsapp.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { InvalidUrlGuard } from './auth/invalid-url.guard';
import { ActiveSessionGuard } from './auth/active-session.guard';
import { MfaGuard } from './auth/mfa.guard';
import { UnfinishedLoginGuard } from './auth/unfinished-login.guard';
import { MfaCompletedGuard } from './auth/mfa-completed.guard';
import { SolConsentGuard } from './auth/sol-consent.guard';
import { SolJourneyGuard } from './auth/sol-journey.guard';


export const appRoutes: Routes = [
  {
    path: 'portal', component: LayoutComponent, canActivate: [AuthGuard, SolJourneyGuard, MfaGuard],
    children: [
      {
        path: 'home',
       loadComponent:()=>import('./landing/landing.component').then(m=>m.LandingComponent)
      },
      {
        path: 'dashboard', 
        loadComponent:()=>import('./dashboard/dashboard.component').then(m=>m.DashboardComponent)
      },
      {
        path: 'profile',
        loadComponent:()=>import('./profile/profile.component').then(m=>m.ProfileComponent)
  
      },
      {
        path: 'setting', 
        loadComponent:()=>import('./setting/setting.component').then(m=>m.SettingComponent)
      },
      {
        path: 'offers',
        resolve: {
          completeProductsData: productResolver
        },
        loadComponent:()=>import('./products/products.component').then(m=>m.ProductsComponent)
      },
      {
        path: 'account',
        resolve: {
          completeAccountsData: accountResolverService
        },
        loadComponent:() => import('./account/account.component').then(m=> m.AccountComponent)
      },
      {
        path: 'faq',
        loadComponent:() => import('./faq/faq.component').then(m=> m.FaqComponent)
      },
      {
        path: 'budget',
        loadComponent:() => import('./budget/budget.component').then(m=> m.BudgetComponent)
      },
      {
        path: 'wealth-score',
        loadComponent:()=>import('./wealth-score/wealth-score.component').then(m=>m.WealthScoreComponent)
      },
      {
        path: 'tfg-whatsapp',
        component: TfgWhatsappComponent
      },
      {
        path:'page-not-found',
        loadComponent:()=>import('./page-not-found/page-not-found.component').then(m=>m.PageNotFoundComponent)
      }
    ]
  },
  {
    path: 'register', component: RegisterComponent, canActivate: [UnfinishedLoginGuard]
  },
  {
    path: 'terms', component: TermsComponent
  },
  {
    path: 'forgot', component: ForgotComponent
  },
  {
    path: 'policy', component: PolicyComponent
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'authenticate',
    canActivate: [ActiveSessionGuard, MfaCompletedGuard],
    loadComponent: () => import('./authenticate/authenticate.component').then(m => m.AuthenticateComponent)
  },
  {
    path: 'saml-login', component: SamlLoginComponent
  },
  {
    path: 'create-password', component: CreatePasswordComponent
  },
  {
    path: 'security-question', component: SecurityQuestionComponent
  },
  {
    path: 'hl-registration', component: HLRegistrationComponent
  },
  {
    path: 'scs-consent',
    canActivate: [SolConsentGuard],
    loadComponent: () => import('./scs-consent/scs-consent.component').then(m => m.ScsConsentComponent)
  },
  {
    path: 'branch', component: PageNotFoundComponent
  },
  { 
    path: '', component: RegisterComponent, canActivate: [UnfinishedLoginGuard]
  },
  {
    path: 'article/:title/:id',
    loadComponent:()=>import('./article/article.component').then(m=>m.ArticleComponent)
  },
  {
    path: 'otp', component: OtpComponent
  },
  {
    path: 'sq-redirect', component: SecuityquestionredirectComponent
  },
  {
    path: 'binary-security-question',
    canActivate: [AuthGuard],
    loadComponent: () => import('./binary-security-question/binary-security-question.component')
      .then(m => m.BinarySecurityQuestionComponent)
  },
  {
    path: 'binary-sq-redirect',
    canActivate: [AuthGuard],
    loadComponent: () => import('./binary-sq-redirect/binary-sq-redirect.component')
      .then(m => m.BinarySqRedirectComponent)
  },
  {
    path:'page-not-found',component:PageNotFoundComponent
  },
  {
    path: '**',
    canActivate: [InvalidUrlGuard],
    component: RegisterComponent
  }


];
